export default "/_next/static/images/smallMembershipBannerBg-ce438604b1936a52cc6914ffc2ab8c0d.png";